import { ClockCircleOutlined } from "@ant-design/icons";
import { Card, Empty, Tag, Typography } from "antd";

interface PlaceholderPageProps {
  title: string;
}

export function PlaceholderPage({ title }: PlaceholderPageProps) {
  return (
    <main className="placeholder-page">
      <div className="page-heading">
        <div>
          <Tag color="blue">M2+</Tag>
          <Typography.Title level={1}>{title}</Typography.Title>
        </div>
        <Typography.Text type="secondary">当前阶段已强制执行真实角色边界</Typography.Text>
      </div>
      <Card variant="borderless">
        <Empty
          image={<ClockCircleOutlined className="placeholder-icon" />}
          description={`${title}将在对应业务里程碑实现`}
        />
      </Card>
    </main>
  );
}
